import React from 'react'

import Base from '../../_Base'

const Instagram16 = (props) => (
  <Base
    aria-hidden="true"
    focusable="false"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      d="M8 3.89a4.11 4.11 0 1 0 0 8.22 4.11 4.11 0 0 0 0-8.22zM11.3 0a5.87 5.87 0 0 1 1.94.42 3.92 3.92 0 0 1 1.47.92c.406.4.72.885.92 1.42A5.87 5.87 0 0 1 16 4.7v6.6a5.87 5.87 0 0 1-.42 1.99 4.09 4.09 0 0 1-2.34 2.34 5.87 5.87 0 0 1-1.94.37H4.7a5.87 5.87 0 0 1-1.99-.42 3.92 3.92 0 0 1-1.42-.92 3.92 3.92 0 0 1-.92-1.42A5.87 5.87 0 0 1 0 11.3V4.7a5.87 5.87 0 0 1 .42-1.94c.2-.535.514-1.02.92-1.42.4-.406.885-.72 1.42-.92A5.87 5.87 0 0 1 4.7 0zm-.07 1.44H4.77a4.43 4.43 0 0 0-1.49.28 2.48 2.48 0 0 0-.92.6 2.48 2.48 0 0 0-.6.92 4.43 4.43 0 0 0-.28 1.49v6.46a4.43 4.43 0 0 0 .28 1.49c.129.348.334.662.6.92.258.266.572.471.92.6.477.178.98.273 1.49.28h6.46a4.43 4.43 0 0 0 1.49-.28 2.65 2.65 0 0 0 1.52-1.52 4.43 4.43 0 0 0 .28-1.49V4.73a4.43 4.43 0 0 0-.28-1.49 2.48 2.48 0 0 0-.6-.92 2.48 2.48 0 0 0-.92-.6 4.43 4.43 0 0 0-1.49-.28zM9.029 5.526A2.67 2.67 0 0 1 10.67 8 2.67 2.67 0 0 1 8 10.67v-.01a2.67 2.67 0 1 1 1.029-5.134zM12.27 2.77a.96.96 0 1 1 0 1.92.96.96 0 0 1 0-1.92z"
      fillRule="evenodd"
    />
  </Base>
)

export default Instagram16
